import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import api from '../../../../services/API';
import { toast } from 'react-toastify';

export default function ModalEditarPrevisaoEntrega({ show, onHide, resgate, onSuccess }) {
  const [previsaoEntrega, setPrevisaoEntrega] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.put(`/api/resgates/${resgate}/previsao-entrega`, {
        previsaoEntrega: previsaoEntrega || null
      });
      toast.success('Previsão de entrega atualizada com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000
      });
      onSuccess();
    } catch (error) {
      toast.error('Erro ao atualizar previsão de entrega', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000
      });
      console.error('Erro ao atualizar previsão de entrega:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Previsão de Entrega</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="previsaoEntrega">Data de Previsão</label>
            <input
              type="date"
              className="form-control"
              id="previsaoEntrega"
              value={previsaoEntrega}
              onChange={(e) => setPrevisaoEntrega(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
} 